import Vue from "vue";
import VueRouter from "vue-router";
import DashboardLayout from "../views/Layout/DashboardLayout.vue";
import ProfileLayout from "../views/Layout/ProfileLayout.vue";
import DashboardLayoutVr from "../views/Layout/DashboardLayoutVr.vue";
import PageLayout from "../views/Layout/PageLayout";
import AuthBasicLayout from "../views/Layout/AuthBasicLayout";
import AuthCoverLayout from "../views/Layout/AuthCoverLayout";
import AuthIllustrationLayout from "../views/Layout/AuthIllustrationLayout";





import multiguard from 'vue-router-multiguard';
import Login from '@/components/Login'
import Register from '@/components/Register'
import Contact from '@/components/Contact'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import Card from '@/components/Card'
import QRRedirect from '@/components/QRRedirect'
import InventoryFilter from '@/components/InventoryFilter'
import RentalInventoryFilter from '@/components/RentalInventoryFilter'
import OldCard from '@/components/Card-old'
import Terms from '@/components/Terms';
import GHLCallback from '@/components/GHLCallback'
import AddLinkOutside from '@/components/AddLinkOutside'
import CardAssistant from '@/components/CardAssistant'
import RegisterCompany from '@/components/RegisterCompany'
import ReferralProgram from '@/components/ReferralProgram'
import RegisterBuyer from '@/components/RegisterBuyer'
import Profile from '@/components/Profile'
import MyReferrals from '@/components/MyReferrals'
import Pricing from '@/components/Pricing'
import Affiliate from '@/components/Affiliate'
import CardInventoryDetail from '@/components/CardInventoryDetail'
import VehicleDetailPage from '@/components/VehicleDetailPage'
import CardRentalInventoryDetail from '@/components/CardRentalInventoryDetail'
import Subscription from '@/components/Admin/Subscription'
import Shares from '@/components/Admin/Shares'
import Conversations from "../components/Admin/Conversations.vue";
import PricingAdmin from '@/components/PricingAdmin'
import ClientSettings from '@/components/Admin/ClientSettings'
import VideoDetail from '@/components/Admin/VideoDetail'
import AddVideoLink from '@/components/Admin/AddVideoLink'
import Agreement from '@/components/Admin/Agreement'
import ManageBooking from '@/components/Admin/ManageBooking'
import DemoBookings from '@/components/Admin/DemoBookings'

import CardInventory from '@/components/CardInventory'
import CardRentalInventory from '@/components/CardRentalInventory'
import RentalLogin from '@/components/Rental/RentalLogin'
import RentalDashboard from '@/components/Rental/RentalDashboard'
import RestartProcess from '@/components/RestartProcess'
import AddRequest from '@/components/AddRequest'
import Thanks from '@/components/Thanks'
import CardPayment from '@/components/CardPayment'
import SpinningWheelGame from '@/components/Games/SpinningWheelGame'
import SpinningWheelAdmin from '@/components/Admin/SpinningWheelAdmin'
import MyVCard from '@/components/MyVCard'
import Step1 from '@/components/Step1'
import LoginAdmin from '@/components/Admin/LoginAdmin'
import Domain from '@/components/Admin/Domain'
import AddCard from '@/components/Admin/AddCard'
import VehicleDetail from '@/components/Admin/VehicleDetail'
import ProdigyWorkArea from '@/components/Admin/ProdigyWorkArea'
import Affiliates from '@/components/Admin/Affiliates'
import LoginDashboard from '@/components/Admin/LoginDashboard'
import Cards from '@/components/Admin/Cards'
import Contacts from '@/components/Admin/Contacts'
import Products from '@/components/Admin/Products'
import VideoLinks from '@/components/Admin/VideoLinks'
import AddContact from '@/components/Admin/AddContact'
import AdminDashboard from '@/components/Admin/AdminDashboard'
import GrantDashboard from '@/components/Admin/GrantDashboard'
import CreditHistory from '@/components/Admin/CreditHistory'
import ContractTemplates from '@/components/Admin/ContractTemplates'
import CustomLinkClient from '@/components/CustomLinkClient'
import CompanyProfiles from '@/components/Admin/CompanyProfiles'
import Agreements from '@/components/Admin/Agreements'
import Reviews from '@/components/Reviews'
import AddReview from '@/components/AddReview'
import AdminReviews from '@/components/Admin/AdminReviews'
import SetPassword from '@/components/SetPassword'
import ClientDashboard from '@/components/ClientDashboard'
import ClientProfiles from '@/components/Admin/ClientProfiles'
import Leads from '@/components/Admin/Leads'
import PreviewProducts from '@/components/Admin/PreviewProducts'
import DealerPortalHome from '@/components/Dealers/DealerPortalHome'
import DealerAbout from '@/components/Dealers/DealerAbout'
import DealerTerms from '@/components/Dealers/DealerTerms'
import DealerPrivacy from '@/components/Dealers/DealerPrivacy'
import DealerSignup from '@/components/Dealers/DealerSignup'
import DealerLogin from '@/components/Dealers/DealerLogin'
import DealerDashboard from '@/components/Dealers/DealerDashboard'
import DealerCommission from '@/components/Dealers/DealerCommission'
import DealerDistribution from '@/components/Dealers/DealerDistribution'
import DealerInventory from '@/components/Dealers/DealerInventory'
import DealerReferringAgents from '@/components/Dealers/DealerReferringAgents'
import DealerPayouts from '@/components/Dealers/DealerPayouts'
import DealerSettings from '@/components/Dealers/DealerSettings'
import DealerProfile from '@/components/Dealers/DealerProfile'
import BeamerClubAssistant from '@/views/BeamerClubAssistant'
import BeamerClubReferral from '@/components/BeamerClubReferral'
import LeadDashboard from '@/components/LeadDashboard'
import ClientProfileDetail from '@/components/Admin/ClientProfileDetail'
import AddCompany from '@/components/Admin/AddCompany'
import AddClient from '@/components/Admin/AddClient'
import AddLetter from '@/components/Admin/AddLetter'
import EditLetter from '@/components/Admin/EditLetter'
import CreditReportWizard from '@/components/Admin/CreditReportWizard'
import CreditReportWizardStep3 from '@/components/Admin/CreditReportWizardStep3'
import SendLetter from '@/components/Admin/SendLetter'
import EditCompany from '@/components/Admin/EditCompany'
import EditClient from '@/components/Admin/EditClient'
import Requests from '@/components/Admin/Requests'
import CertifiedLetters from '@/components/Admin/CertifiedLetters'
import MyRequest from '@/components/MyRequest'
import Mailing from '@/components/Admin/Mailing'
import Setting from '@/components/Admin/Setting'
import CustomLink from '@/components/Admin/CustomLink'
import ProfileAdmin from '@/components/Admin/Profile'
import Utility from '@/components/common/functions.js'
import ImportCreditReport from '@/components/Admin/ImportCreditReport'
import PaymentGateway from '@/components/Admin/PaymentGateway'
import PaymentGatewayCompany from '@/components/Admin/PaymentGatewayCompany'
import Cart from '@/components/Admin/Cart'
import Checkout from '@/components/Admin/Checkout'
import CompanyUsers from '@/components/Admin/CompanyUsers'
import AddCompanyUser from '@/components/Admin/AddCompanyUser'
import editCompanyUser from '@/components/Admin/EditCompanyUser'
import Fax from '@/components/Admin/Fax'
import QueuedFax from '@/components/Admin/QueuedFax'
import CompanySettings from '@/components/Admin/CompanySettings'
import ConversationSettings from '@/components/Admin/ConversationSettings'
import ChangePassword from '@/components/ChangePassword'
import FormSales from '@/components/Forms/FormSales'
import FormRef from '@/components/Forms/FormRef'
import EditCard from '@/components/EditCard'
import SubscriptionSettings from '@/components/Admin/SubscriptionSettings'


import ManageSubscription from '@/components/Admin/ManageSubscription'

// Sweepstakes components
import SweepstakesLanding from '@/components/Sweepstakes/SweepstakesLanding.vue'
import SweepstakesEntry from '@/components/Sweepstakes/SweepstakesEntry.vue'
import SweepstakesCheckout from '@/components/Sweepstakes/SweepstakesCheckout.vue'
import SweepstakesConfirmation from '@/components/Sweepstakes/SweepstakesConfirmation.vue'
import SweepstakesTerms from '@/components/Sweepstakes/SweepstakesTerms.vue'
import SweepstakesAdmin from '@/components/Admin/SweepstakesAdmin.vue'
import ScheduleAdmin from '@/components/Admin/ScheduleAdmin.vue'
import ScheduleHistory from '@/components/Admin/ScheduleHistory.vue'
import ScrapedVehicles from '@/components/Admin/ScrapedVehicles.vue'
import AgentSettings from '@/components/AgentSettings.vue'
import AgentAssistant from '@/components/AgentAssistant.vue'
import ReferringAgentHome from '@/components/Agents/ReferringAgentHome.vue'
import FourPillars from '@/components/FourPillars.vue'























const isLoggedIn = (to, from, next) => {
  if (localStorage.getItem('token')) {
    console.log('isLoggedIn ok...', localStorage.getItem('name'))
    next()
  }
  else {

  }
}

const isAdmin = (to, from, next) => {
  let admin = localStorage.getItem("is_admin")
  let role = localStorage.getItem('role') ? JSON.parse(localStorage.getItem('role')) : {name:'client'};

  if (admin == 1 && localStorage.getItem('token')) {
    console.log('isAdmin ok...', admin)
    if(role.name == 'super_admin' || role.name == 'company_admin')
      next()
    else
      next('/admin/dashboard');
  } else {
    next('/admin/login');
    window.location.reload();
  }
}
const isAdminGeneral = (to, from, next) => {

  let admin = localStorage.getItem("is_admin")
  let role = localStorage.getItem('role') ? JSON.parse(localStorage.getItem('role')) : {name:'client'};

  if (localStorage.getItem('token') && admin == 1) {
    console.log('isAdmin ok...', admin)
    if(role.name == 'super_admin' || role.name == 'company_admin')
      next()
    else
      next('/admin/dashboard');
  } else {
    next('/admin/login');
    window.location.reload();
  }
}
const isCompanyAdminGeneral = (to, from, next) => {

  let admin = localStorage.getItem("is_admin")
  let role = localStorage.getItem('role') ? JSON.parse(localStorage.getItem('role')) : {name:'client'};

  if (localStorage.getItem('token') && admin == 1) {
    console.log('isAdmin ok...', admin)
    if(role.name == 'super_admin' || role.name == 'company_admin' || role.name == 'company_user')
      next()
    else
      next('/admin/dashboard');
  } else {
    next('/admin/login');
    window.location.reload();
  }
}
const isClient= (to, from, next) => {

  let admin = localStorage.getItem("is_admin")
  let role = localStorage.getItem('role') ? JSON.parse(localStorage.getItem('role')) : {name:'client'};

  if (localStorage.getItem('token')) {
    if(role.name == 'client' || role.name == 'sales_rep' || role.name == 'referring_rep' || role.name == 'sweepstakes_user' || role.name == 'lead')
      next()
    else
      next('/dashboard');
  } else {
    // Store the intended destination for redirect after login
    localStorage.setItem('redirect_after_login', to.fullPath);
    next('/login');
    window.location.reload();
  }
}
const documentExist = (to, from, next) => {

  let admin = localStorage.getItem("document_flag") ? localStorage.getItem("document_flag") : false;
  if (localStorage.getItem('token')) {
    // if(admin)
      // next('/profile');
    // else
      next()
  } else {
    next('/login');
    window.location.reload();
  }
}
// Dashboard pages
const Dashboard = () => import("../views/Dashboard/Dashboard.vue");
const Discover = () => import("../views/Dashboard/Discover.vue");
const Automotive = () => import("../views/Dashboard/Automotive.vue");
const Sales = () => import("../views/Dashboard/Sales.vue");
const SmartHome = () => import("../views/Dashboard/SmartHome.vue");
const VrDefault = () => import("../views/Dashboard/VrDefault.vue");
const VrInfo = () => import("../views/Dashboard/VrInfo.vue");
const Crm = () => import("../views/Dashboard/Crm.vue");
const GettingStarted = () => import("../views/Dashboard/GettingStarted.vue");

// Pages
// const Pricing = () =>
//   import(/* webpackChunkName: "pages" */ "@/views/Pages/Pricing.vue");
const Rtl = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Rtl.vue");
const ProfileOverview = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Pages/Profile/ProfileOverview.vue"
  );
const Messages = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Profile/Messages.vue");
const Projects = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Profile/Projects.vue");
const Reports = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Users/Reports.vue");
const NewUser = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Users/NewUser.vue");
const Settings = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Account/Settings.vue");
const Billing = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Account/Billing.vue");
const Invoice = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Account/Invoice.vue");
const Timeline = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Projects/Timeline.vue");
const Charts = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Charts.vue");
const Alerts = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Alerts.vue");
const Notifications = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Notifications.vue");
const SignUpBasic = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Pages/Authentication/SignUp/Basic.vue"
  );
const SignUpCover = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Pages/Authentication/SignUp/Cover.vue"
  );
const SignUpIllustration = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Pages/Authentication/SignUp/Illustration.vue"
  );

// Applications
const Kanban = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Applications/Kanban.vue");
const Wizard = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Applications/Wizard.vue");
const Datatables = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Applications/Datatables.vue");
const Calendar = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Applications/Calendar.vue");

// Ecommerce
const NewProduct = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Ecommerce/Products/NewProduct.vue"
  );
const EditProduct = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Ecommerce/Products/EditProduct.vue"
  );
const ProductPage = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Ecommerce/Products/ProductPage.vue"
  );
const OrderList = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Ecommerce/Orders/OrderList.vue"
  );
const OrderDetails = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Ecommerce/Orders/OrderDetails.vue"
  );

Vue.use(VueRouter);

let vrPages = {
  path: "/",
  component: DashboardLayoutVr,
  name: "Vr",
  children: [
    {
      path: "/pages/dashboards/vr/vr-default",
      name: "VrDefault",
      component: VrDefault,
      meta: {
        groupName: "Dashboards",
      },
    },
    {
      path: "/pages/dashboards/vr/vr-info",
      name: "VrInfo",
      component: VrInfo,
      meta: {
        groupName: "Dashboards",
      },
    },
  ],
};

let profilePages = {
  path: "/",
  component: ProfileLayout,
  name: "Profile",
  children: [
    {
      path: "/pages/pages/profile/overview",
      name: "ProfileOverview",
      component: ProfileOverview,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/profile/messages",
      name: "Messages",
      component: Messages,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/profile/projects",
      name: "Project",
      component: Projects,
      meta: {
        groupName: "Pages",
      },
    },
  ],
};

let userPages = {
  path: "/",
  component: DashboardLayout,
  name: "Users",
  children: [
    {
      path: "/pages/pages/users/reports",
      name: "Reports",
      component: Reports,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/users/new-user",
      name: "NewUser",
      component: NewUser,
      meta: {
        groupName: "Pages",
      },
    },
  ],
};

let accountPages = {
  path: "/",
  component: DashboardLayout,
  name: "Account",
  children: [
    {
      path: "/pages/pages/account/settings",
      name: "Settings",
      component: Settings,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/account/billing",
      name: "Billing",
      component: Billing,
      meta: {
        groupName: "Pages",
      },
    },
    {
      path: "/pages/pages/account/invoice",
      name: "Invoice",
      component: Invoice,
      meta: {
        groupName: "Pages",
      },
    },
  ],
};

let projectsPages = {
  path: "/",
  component: DashboardLayout,
  name: "Projects",
  children: [
    {
      path: "/pages/pages/projects/timeline",
      name: "Timeline",
      component: Timeline,
      meta: {
        groupName: "Pages",
      },
    },
  ],
};

let applicationPages = {
  path: "/",
  component: DashboardLayout,
  name: "Application",
  children: [
    {
      path: "/pages/applications/kanban",
      name: "Kanban",
      component: Kanban,
      meta: {
        groupName: "Applications",
      },
    },
    {
      path: "/pages/applications/wizard",
      name: "Wizard",
      component: Wizard,
      meta: {
        groupName: "Applications",
      },
    },
    {
      path: "/pages/applications/datatables",
      name: "Datatables",
      component: Datatables,
      meta: {
        groupName: "Applications",
      },
    },
    {
      path: "/pages/applications/calendar",
      name: "Calendar",
      component: Calendar,
      meta: {
        groupName: "Applications",
      },
    },
  ],
};

// let pricingPage = {
//   path: "/",
//   component: PageLayout,
//   name: "Pricing Page",
//   children: [
//     {
//       path: "/pages/pages/pricing-page",
//       name: "Pricing",
//       component: Pricing,
//     },
//   ],
// };

let authBasicPages = {
  path: "/",
  component: AuthBasicLayout,
  name: "Authentication Basic",
  children: [
    {
      path: "/pages/authentication/signup/basic",
      name: "SignUpBasic",
      component: SignUpBasic,
    },
  ],
};

let authCoverPages = {
  path: "/",
  component: AuthCoverLayout,
  name: "Authentication Cover",
  children: [
    {
      path: "/pages/authentication/signup/cover",
      name: "SignUpCover",
      component: SignUpCover,
    },
  ],
};

let authIllustrationPages = {
  path: "/",
  component: AuthIllustrationLayout,
  name: "Authentication Illustration",
  children: [
    {
      path: "/pages/authentication/signup/illustration",
      name: "SignUpIllustration",
      component: SignUpIllustration,
    },
  ],
};

const routes = [
  {
    path: "/",
    name: "Card",
    components: {
        default: Card
      }
  },
    {
    path: "/card-assistant",
    name: "CardAssistant",
    components: {
        default: CardAssistant
      }
  },
  {
    path: "/admin/client-profile-detail/:id",
      name: "ClientProfileDetail",
      // beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ClientProfileDetail
      },
      // beforeEnter: multiguard([isCompanyAdminGeneral])
  },


  {
    path: "/add-request",
    name: "AddRequest",
    components: {
        default: AddRequest
    }
  },
  {
    path: "/auth/reset/:token/:email",
    name: "SetPassword",
    components: {
        default: SetPassword
    }
  },
  // { path: "*", component: Login },
  {
      path: "/signup/:url?",
      name: "Register",
      components: {
          default: Register
      }
  },
  {
      path: "/signup-agent",
      name: "SignupAgent",
      component: () => import("@/components/SignupAgent.vue")
  },
  {
    path: "/signup-company/:url?",
    name: "RegisterCompany",
    components: {
        default: RegisterCompany
    }
  },
  {
    path: "/apply-online",
    name: "RegisterBuyer",
    components: {
        default: RegisterBuyer
    }
  },
  // Dealer Portal Routes
  {
    path: "/dealers",
    name: "DealerPortalHome",
    components: {
      default: DealerPortalHome
    }
  },
  {
    path: "/dealers/home",
    name: "DealerPortalHomeAlt",
    components: {
      default: DealerPortalHome
    }
  },
  {
    path: "/dealers/about",
    name: "DealerAbout",
    components: {
      default: DealerAbout
    }
  },
  {
    path: "/dealers/terms",
    name: "DealerTerms",
    components: {
      default: DealerTerms
    }
  },
  {
    path: "/dealers/privacy",
    name: "DealerPrivacy",
    components: {
      default: DealerPrivacy
    }
  },
  {
    path: "/dealers/signup",
    name: "DealerSignup",
    components: {
      default: DealerSignup
    }
  },
  {
    path: "/dealers/login",
    name: "DealerLogin",
    components: {
      default: DealerLogin
    }
  },
  {
    path: "/dealers/dashboard",
    name: "DealerDashboard",
    components: {
      default: DealerDashboard
    }
  },
  {
    path: "/dealers/commission",
    name: "DealerCommission",
    components: {
      default: DealerCommission
    }
  },
  {
    path: "/dealers/distribution",
    name: "DealerDistribution",
    components: {
      default: DealerDistribution
    }
  },
  {
    path: "/dealers/inventory",
    name: "DealerInventory",
    components: {
      default: DealerInventory
    }
  },
  {
    path: "/dealers/referring-agents",
    name: "DealerReferringAgents",
    components: {
      default: DealerReferringAgents
    }
  },
  {
    path: "/dealers/payouts",
    name: "DealerPayouts",
    components: {
      default: DealerPayouts
    }
  },
  {
    path: "/dealers/profile",
    name: "DealerProfile",
    components: {
      default: DealerProfile
    }
  },
  {
    path: "/dealers/settings",
    name: "DealerSettings",
    components: {
      default: DealerSettings
    }
  },

  // Referring Agent Routes
  {
    path: "/agents",
    name: "ReferringAgentHome",
    components: {
      default: ReferringAgentHome
    }
  },
  {
    path: "/agents/home",
    redirect: "/agents"
  },

  // Four Pillars Coalition Page
  {
    path: "/four-pillars",
    name: "FourPillars",
    components: {
      default: FourPillars
    }
  },

  { path: "*", component: Login },
  {
      path: "/login/:url?",
      name: "Login",
      components: {
          default: Login
      }
  },
  {
    path: "/step1/:id?",
    name: "Step1",
    beforeEnter: isClient,
    components: {
        default: Step1
    }
  },
  {
  path: "/restart-process/:id",
  name: "RestartProcess",
  beforeEnter: isClient,
  components: {
      default: RestartProcess
  }
  },
  {
  path: "/my-request",
  name: "MyRequest",
  beforeEnter: isClient,
  components: {
      default: MyRequest
  }
  },
  {
    path: "/thanks",
    name: "Thanks",
    components: {
        default: Thanks
    }
  },
  {
    path: "/profile",
    name: "Profile",
    beforeEnter: isClient,
    components: {
        default: Profile
    }
  },
  {
    path: "/my-referrals",
    name: "MyReferrals",
    beforeEnter: isClient,
    components: {
        default: MyReferrals
    }
  },
  {
    path: "/terms-and-conditions",
    name: "Terms",
    components: {
        default: Terms
    }
  },
  {
    path: "/form-sales/:id",
    name: "FormSales",
    components: {
        default: FormSales
    }
  },
  {
    path: "/form-ref/:id/:agent?",
    name: "FormRef",
    components: {
        default: FormRef
    }
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    beforeEnter: isClient,
    components: {
        default: ChangePassword
    }
  },
  {
    path: "/agent-settings",
    name: "AgentSettings",
    beforeEnter: isClient,
    components: {
        default: AgentSettings
    }
  },
  {
    path: "/assistant/:subdomain?",
    name: "AgentAssistant",
    components: {
        default: AgentAssistant
    }
  },
  {
    path: "/beamer-club-assistant",
    name: "BeamerClubAssistant",
    components: {
        default: BeamerClubAssistant
    }
  },
  {
    path: "/beamer-club-referral/:trackingId",
    name: "BeamerClubReferral",
    components: {
        default: BeamerClubReferral
    }
  },
  {
    path: "/lead-dashboard",
    name: "LeadDashboard",
    beforeEnter: isClient,
    components: {
        default: LeadDashboard
    }
  },

  {
  path: "/dashboard",
  name: "ClientDashboard",
  beforeEnter: isClient,
  components: {
      default: ClientDashboard
  }
  },
  {
    path: "/edit-card",
    name: "EditCard",
    beforeEnter: isClient,
    components: {
        default: EditCard
    }
    }
  ,
  {
    path: "/admin/login/:url?",
    name: "LoginAdmin",
    components: {
        default: LoginAdmin
    }
  },
  {
    path: "/privacy/:url?",
    name: "PrivacyPolicy",
    components: {
        default: PrivacyPolicy
    }
  },
  {
    path: "/choose-profile",
    name: "LoginDashboard",
    components: {
        default: LoginDashboard
    }
  },
  {
    path: "/admin",
    name: "LoginAdmin",
    components: {
        default: LoginAdmin
    }
  },
  {
    path: "/ghl/callback",
    name: "GHLCallback",
    components: {
        default: GHLCallback
    }
  },
  {
    path: "/admin/preview-products",
    name: "PreviewProducts",
    beforeEnter:isCompanyAdminGeneral,
    components: {
        default: PreviewProducts
    },
    beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/vehicle-detail/:id",
    name: "VehicleDetail",
    beforeEnter:isCompanyAdminGeneral,
    components: {
        default: VehicleDetail
    },
    beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/agreement",
    name: "Agreement",
    components: {
        default: Agreement
    },
  },
  {
    path: "/referral-program",
    name: "ReferralProgram",
    components: {
        default: ReferralProgram
    },
  },
  {
  path: "/admin/spinning-wheel",
    name: "SpinningWheelAdmin",
    component: SpinningWheelAdmin,
    beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/sweepstakes",
    name: "SweepstakesAdmin",
    component: SweepstakesAdmin,
    beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/schedules",
    name: "ScheduleAdmin",
    component: ScheduleAdmin,
    beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/schedule-history/:id",
    name: "ScheduleHistory",
    component: ScheduleHistory,
    beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/scraped-vehicles/:id",
    name: "ScrapedVehicles",
    component: ScrapedVehicles,
    beforeEnter: multiguard([isAdmin])
  },

  {
    path: "/admin/agreements",
    name: "Agreements",
    components: {
        default: Agreements
    },
    beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/subscription-settings",
    name: "SubscriptionSettings",
    beforeEnter:isAdmin,
    components: {
        default: SubscriptionSettings
    },
    beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/dashboard",
      name: "Dashboard",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: AdminDashboard
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/grant-dashboard",
      name: "Grant Dashboard",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: GrantDashboard
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/payment-gateway",
      name: "Payment Gateway",
      beforeEnter: isAdmin,
      components: {
          default: PaymentGateway
      }
  },
  {
    path: "/admin/payment-gateway-company",
      name: "Payment Gateway",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: PaymentGatewayCompany
      }
  },
  {
    path: "/admin/contract-templates",
      name: "ContractTemplates",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ContractTemplates
      }
  },
  {
    path: "/admin/custom-link/:id",
      name: "CustomLink",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: CustomLink
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/custom-link/:id",
      name: "CustomLinkClient",
      components: {
          default: CustomLinkClient
      },
  },
  {
    path: "/admin/credit-report/:id",
      name: "Import Credit Report",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ImportCreditReport
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/credit-report-wizard/:id",
      name: "CreditReportWizard",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: CreditReportWizard
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/send-letter/:id",
      name: "Send Letter",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: SendLetter
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/credit-report-wizard-step-3/:id",
      name: "Credit Report WizardStep 3",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: CreditReportWizardStep3
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },




  {
    path: "/credit-report/:id",
      name: "Import Credit Report",
      components: {
          default: ImportCreditReport
      },
  },
  {
    path: "/credit-report-wizard/:id",
      name: "Credit Report Wizard",
      components: {
          default: CreditReportWizard
      },
  },
  {
    path: "/send-letter/:id",
      name: "Send Letter",
      components: {
          default: SendLetter
      },
  },
  {
    path: "/credit-report-wizard-step-3/:id",
      name: "Credit Report Wizard Step 3",
      components: {
          default: CreditReportWizardStep3
      },
  },


  {
    path: "/admin/credit-history",
      name: "Credit History",
      beforeEnter: isAdminGeneral,
      components: {
          default: CreditHistory
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/credit-history",
      name: "Credit History",
      beforeEnter: isClient,
      components: {
          default: CreditHistory
      },
  },
  {
    path: "/admin/my-profile",
      name: "Profile",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ProfileAdmin
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/company-settings",
      name: "Company Settings",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: CompanySettings
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/manage-subscription",
      name: "Manage Subscription",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ManageSubscription
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/client-profiles",
      name: "Client Profiles",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ClientProfiles
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/leads",
      name: "Leads",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: Leads
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/client-settings",
      name: "Client Settings",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ClientSettings
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/client-profile-detail/:id",
      name: "Client Profile Detail",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ClientProfileDetail
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/conversation-settings",
      name: "Conversation Settings",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ConversationSettings
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/company-profiles",
      name: "Company Profiles",
      beforeEnter: isAdmin,
      components: {
          default: CompanyProfiles
      },
      beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/contact/:id",
      name: "Contact",
      components: {
          default: Contact
      }
  },
  {
    path: "/redirect-qr/:id",
      name: "QRRedirect",
      components: {
          default: QRRedirect
      },
  },
  {
    path: "/card/:id",
      name: "Card",
      components: {
          default: Card
      }
  },
  {
    path: "/old-card/:id?",
      name: "OldCard",
      components: {
          default: OldCard
      }
  },
  {
    path: "/card-payment/:id",
      name: "CardPayment",
      components: {
          default: CardPayment
      }
  },
  {
    path: "/admin/add-company",
      name: "Add Company",
      beforeEnter: isAdmin,
      components: {
          default: AddCompany
      },
      beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/add-contact/:id?",
      name: "Add Contact",
      beforeEnter: isAdminGeneral,
      components: {
          default: AddContact
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/add-card/:id?",
      name: "Add Card",
      beforeEnter: isAdminGeneral,
      components: {
          default: AddCard
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/my-vcard",
      name: "My Card",
      components: {
          default: MyVCard
      }
  },
  {
    path: "/view-inventory",
      name: "CardInventory",
      components: {
          default: CardInventory
      }
  },
  {
    path: "/view-rental-inventory",
      name: "CardRentalInventory",
      components: {
          default: CardRentalInventory
      }
  },
  {
    path: "/inventory-filter",
      name: "CardInventory",
      components: {
          default: InventoryFilter
      }
  },
  {
    path: "/inventory",
    name: "Inventory",
    components: {
        default: () => import("@/components/Inventory.vue")
    }
  },
  {
    path: "/rental-inventory-filter",
    name: "CardRentalInventory",
    components: {
        default: RentalInventoryFilter
    }
  },
  {
    path: "/reviews",
      name: "Reviews",
      components: {
          default: Reviews
      }
  },

  {
    path: "/addreview",
      name: "AddReview",
      components: {
          default: AddReview
      }
  },
  {
    path: "/admin/reviews",
      name: "AdminReviews",
      components: {
          default: AdminReviews
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/view-inventory-details/:id",
      name: "VehicleDetailPage",
      components: {
          default: VehicleDetailPage
      }
  },
  {
    path: "/view-rental-inventory-details/:id",
      name: "CardRentalInventoryDetail",
      components: {
          default: CardRentalInventoryDetail
      }
  },
  {
    path: "/admin/add-video-link/:id?",
      name: "AddVideoLink",
      beforeEnter: isAdminGeneral,
      components: {
          default: AddVideoLink
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/affiliate",
      name: "Affiliate",
      components: {
          default: Affiliate
      },
  },
  {
    path: "/add-video-link",
      name: "Add Links",
      components: {
          default: AddLinkOutside
      },
  },
  {
    path: "/admin/contacts",
      name: "Contacts",
      beforeEnter: isAdminGeneral,
      components: {
          default: Contacts
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/shares",
      name: "Shares",
      beforeEnter: isAdminGeneral,
      components: {
          default: Shares
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/conversations",
      name: "Conversations",
      beforeEnter: isAdminGeneral,
      components: {
          default: Conversations
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/cards",
      name: "Cards",
      beforeEnter: isAdminGeneral,
      components: {
          default: Cards
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/products",
      name: "Products",
      beforeEnter: isAdminGeneral,
      components: {
          default: Products
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/video-links",
      name: "Video Links",
      beforeEnter: isAdminGeneral,
      components: {
          default: VideoLinks
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/video-detail/:id",
      name: "Video Detail",
      beforeEnter: isAdminGeneral,
      components: {
          default: VideoDetail
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/add-company-user",
      name: "Add Company User",
      beforeEnter: isAdminGeneral,
      components: {
          default: AddCompanyUser
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/add-letter",
      name: "Add Letter",
      beforeEnter: isAdminGeneral,
      components: {
          default: AddLetter
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/edit-letter/:id",
      name: "Edit Letter",
      beforeEnter: isAdminGeneral,
      components: {
          default: EditLetter
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/settings",
      name: "Settings",
      beforeEnter: isAdmin,
      components: {
          default: Setting
      },
      beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/affiliates",
      name: "Affiliates",
      beforeEnter: isAdmin,
      components: {
          default: Affiliates
      },
      beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/pricing",
      name: "Pricing",
      beforeEnter: isAdminGeneral,
      components: {
          default: PricingAdmin
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/subscription",
      name: "Subscription",
      beforeEnter: isAdminGeneral,
      components: {
          default: Subscription
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/company-users",
      name: "Company Users",
      beforeEnter: isAdminGeneral,
      components: {
          default: CompanyUsers
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/pricing",
      name: "Pricing",
      beforeEnter: isClient,
      components: {
          default: Pricing
      },
  },
  {
    path: "/admin/edit-company/:id",
      name: "Edit Company",
      beforeEnter: isAdmin,
      components: {
          default: EditCompany
      },
      beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/edit-company-user/:id",
      name: "Edit Company User",
      beforeEnter: isAdminGeneral,
      components: {
          default: editCompanyUser
      },
      beforeEnter: multiguard([isAdminGeneral])
  },
  {
    path: "/admin/add-client",
      name: "Add Client",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: AddClient
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/rental-bookings",
      name: "manage-booking",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ManageBooking
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/demo-bookings",
      name: "demo-bookings",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: DemoBookings
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/domain",
      name: "Custom Domain",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: Domain
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/prodigy-letters",
      name: "Prodigy",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: ProdigyWorkArea
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/edit-client/:id",
      name: "Edit Client",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: EditClient
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/requests",
      name: "Requests",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: Requests
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/certified-letters",
      name: "Certified Letters",
      beforeEnter: isCompanyAdminGeneral,
      components: {
          default: CertifiedLetters
      },
      beforeEnter: multiguard([isCompanyAdminGeneral])
  },
  {
    path: "/admin/mailing",
      name: "Mailing",
      beforeEnter: isAdmin,
      components: {
          default: Mailing
      },
      beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/fax",
      name: "Fax",
      beforeEnter: isAdmin,
      components: {
          default: Fax
      },
      beforeEnter: multiguard([isAdmin])
  },
  {
    path: "/admin/queued-fax",
      name: "Queued Fax",
      beforeEnter: isAdmin,
      components: {
          default: QueuedFax
      },
      beforeEnter: multiguard([isAdmin])
  },
  {
    path: '/admin/cart',
    name: 'Cart',
    component: Cart,
    beforeEnter: isAdmin,
    component: function (resolve) {
      require(['@/components/Admin/Cart.vue'], resolve)
    },
    beforeEnter: multiguard([isAdmin])
  },
  {
    path: '/admin/checkout',
    name: 'Checkout',
    component: Checkout,
    beforeEnter: isAdmin,
    component: function (resolve) {
      require(['@/components/Admin/Checkout.vue'], resolve)
    },
    beforeEnter: multiguard([isAdmin])
  },





















































  {
    path: "/",
    name: "Dashboard",
    redirect: "/pages/dashboards/analytics",
    component: DashboardLayout,
    children: [
      {
        path: "pages/dashboards/analytics",
        name: "Analytics",
        component: Dashboard,
        meta: {
          groupName: "Dashboards",
        },
      },
      {
        path: "pages/dashboards/discover",
        name: "Discover",
        component: Discover,
        meta: {
          groupName: "Dashboards",
        },
      },
      {
        path: "/pages/dashboards/smart-home",
        name: "SmartHome",
        component: SmartHome,
        meta: {
          groupName: "Dashboards",
        },
      },
      {
        path: "/pages/dashboards/crm",
        name: "Crm",
        component: Crm,
        meta: {
          groupName: "Components",
        },
      },
      {
        path: "/pages/dashboards/automotive",
        name: "Automotive",
        component: Automotive,
        meta: {
          groupName: "Dashboards",
        },
      },
      {
        path: "/pages/dashboards/sales",
        name: "Sales",
        component: Sales,
        meta: {
          groupName: "Dashboards",
        },
      },
      {
        path: "/pages/pages/rtl",
        name: "RTL",
        component: Rtl,
        meta: {
          groupName: "Components",
        },
      },
      {
        path: "/pages/pages/charts",
        name: "Charts",
        component: Charts,
        meta: {
          groupName: "Components",
        },
      },
      {
        path: "/pages/pages/alerts",
        name: "Alerts",
        component: Alerts,
        meta: {
          groupName: "Components",
        },
      },
      {
        path: "/pages/pages/notifications",
        name: "Notifications",
        component: Notifications,
        meta: {
          groupName: "Components",
        },
      },
      {
        path: "getting-started",
        name: "Getting Started",
        component: GettingStarted,
        meta: {
          groupName: "Components",
        },
      },
      {
        path: "/pages/ecommerce/products/new-product",
        name: "NewProduct",
        component: NewProduct,
        meta: {
          groupName: "Ecommerce",
        },
      },
      {
        path: "/pages/ecommerce/products/edit-product",
        name: "EditProduct",
        component: EditProduct,
        meta: {
          groupName: "Ecommerce",
        },
      },
      {
        path: "/pages/ecommerce/products/product-page",
        name: "ProductPage",
        component: ProductPage,
        meta: {
          groupName: "Ecommerce",
        },
      },
      {
        path: "/pages/ecommerce/orders/list",
        name: "OrderList",
        component: OrderList,
        meta: {
          groupName: "Ecommerce",
        },
      },
      {
        path: "/pages/ecommerce/orders/details",
        name: "OrderDetails",
        component: OrderDetails,
        meta: {
          groupName: "Ecommerce",
        },
      },
    ],
  },
  // pricingPage,
  profilePages,
  applicationPages,
  userPages,
  accountPages,
  projectsPages,
  vrPages,
  authBasicPages,
  authCoverPages,
  authIllustrationPages,
  {
    path: "/rental/login",
    name: "RentalLogin",
    component: RentalLogin,
  },
  {
    path: "/rental/dashboard",
    name: "RentalDashboard",
    component: RentalDashboard,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('rental_token')) {
        next();
      } else {
        next('/rental/login');
      }
    }
  },
  {
    path: "/rental/profile",
    name: "RentalProfile",
    component: () => import("../views/rental/Profile.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('rental_token')) {
        next();
      } else {
        next('/rental/login');
      }
    }
  },
  {
    path: "/rental/bookings",
    name: "RentalBookings",
    component: () => import("../views/rental/Bookings.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem('rental_token')) {
        next();
      } else {
        next('/rental/login');
      }
    }
  },
  // Spinning Wheel Game Route
  {
    path: "/spin-to-win",
    name: "SpinningWheelGame",
    component: SpinningWheelGame,
  },
  // Spinning Wheel Admin Route
  // {
  //   path: "/admin/spinning-wheel",
  //   name: "SpinningWheelAdmin",
  //   component: SpinningWheelAdmin,
  //   beforeEnter: (to, from, next) => {
  //     if (localStorage.getItem('token') && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'company_admin')) {
  //       next();
  //     } else {
  //       next('/login-admin');
  //     }
  //   }
  // },

  // Sweepstakes Routes
  {
    path: "/sweepstakes",
    name: "SweepstakesLanding",
    component: SweepstakesLanding,
  },
  {
    path: "/sweepstakes/terms",
    name: "SweepstakesTerms",
    component: SweepstakesTerms,
  },
  {
    path: "/sweepstakes/entry/:campaignId",
    name: "SweepstakesEntry",
    component: SweepstakesEntry,
    props: true
  },
  {
    path: "/sweepstakes/checkout/:campaignId/:tierId",
    name: "SweepstakesCheckout",
    component: SweepstakesCheckout,
    props: true
  },
  {
    path: "/sweepstakes/confirmation/:entryId",
    name: "SweepstakesConfirmation",
    component: SweepstakesConfirmation,
    props: true
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

export default router;
